var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[(_vm.authenticated)?_c('router-link',{attrs:{"to":"/login","replace":""},nativeOn:{"click":function($event){return _vm.logout()}}},[_vm._v("Logout")]):_vm._e(),_vm._v(" "),_c('router-view',{on:{"authenticated":_vm.setAuthenticated,"username":_vm.setUsername,"password":_vm.setPassword}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-230f8912","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 